import { DocumentRequest } from '@trustero/trustero-api-web/lib/request/request_pb'

export const normalizeLinkedTicketUrl = (rawUrl: string): string => {
  const trimmed = rawUrl.trim()
  if (!trimmed) return ''
  try {
    const parsed = new URL(trimmed)
    const host = parsed.hostname.trim().toLowerCase()
    const isJiraBrowsePath = /^\/browse\/[^/]+$/i.test(parsed.pathname)
    const hasNoDomain = host !== '' && !host.includes('.')
    if (isJiraBrowsePath && hasNoDomain) {
      parsed.hostname = `${host}.atlassian.net`
      return parsed.toString()
    }
    return trimmed
  } catch {
    return trimmed
  }
}

export type LinkedTicket = {
  key: string
  url: string
  status: string
  receptorId: string
}

// The workflow tickets a request is linked to: its linked workflows when it has any,
// else the single legacy linked ticket. The requests grid shows them and its search
// matches them, so both read them from here.
export const getLinkedTickets = (request: DocumentRequest): LinkedTicket[] => {
  const linkedWorkflowsRaw =
    ((
      request as unknown as { getLinkedWorkflowsList?: () => unknown[] }
    ).getLinkedWorkflowsList?.() as Array<{
      getSourceKey?: () => string
      getUrl?: () => string
      getStatus?: () => string
      getReceptorId?: () => string
    }>) || []

  if (linkedWorkflowsRaw.length > 0) {
    return linkedWorkflowsRaw
      .map((wf) => ({
        key: wf.getSourceKey?.() || '',
        url: wf.getUrl?.() || '',
        status: wf.getStatus?.() || '',
        receptorId: wf.getReceptorId?.() || '',
      }))
      .filter((wf) => wf.key || wf.url || wf.status || wf.receptorId)
  }
  const key = request.getLinkedTicketKey()
  const url = request.getLinkedTicketUrl()
  const status = request.getLinkedTicketStatus()
  if (key || url || status) {
    return [
      { key, url, status, receptorId: request.getLinkedTicketReceptorId() },
    ]
  }
  return []
}
